<template>
  <div class="keyboard-wrapper" :class="{ 'has-keyboard': showKeyboard }">
    <slot />
    <transition name="float">
      <Keyboard v-if="showKeyboard" />
    </transition>
  </div>
</template>

<script>
import Keyboard from '@/components/accessibility/Keyboard'
import { KeyboardStoreNamespacedTypes } from '@/store/keyboard'

/**
 * Wraps anything in a container making space for our custom keyboard when necessary.
 * Requires the keyboard store to be initialized.
 */
export default {
  name: 'KeyboardWrapper',
  components: { Keyboard },
  computed: {
    /**
     * Returns true if an input field requires the custom keyboard to be shown.
     * @returns {boolean}
     */
    showKeyboard() {
      return this.$store.getters[
        KeyboardStoreNamespacedTypes.getters.IS_KEYBOARD_VISIBLE
      ]()
    },
  },
}
</script>

<style lang="scss" scoped>
.keyboard-wrapper {
  &.has-keyboard {
    @media (max-width: 38.75rem) {
      margin-bottom: 20rem;
    }
    @media (min-width: 38.76rem) {
      margin-bottom: 8rem;
    }
  }
}

.keyboard {
  &.float-enter-active {
    transition: opacity var(--transition-fast),
      transform var(--transition-medium) $transitionElastic;
  }
  &.float-leave-active {
    transition: opacity var(--transition-medium) ease-out,
      transform var(--transition-medium) ease-out;
  }

  &.float-enter,
  &.float-leave-to {
    opacity: 0;
    transform: translateY(30%);
  }
}
</style>
